/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { PostUsers201, PostUsers400, PostUsersMutationRequest, PostUsersMutationResponse } from '../entities/PostUsers'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { createUserRequestSchema } from './createUserRequestSchema'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

/**
 * @description Created
 */
export const postUsers201Schema = z.any() as unknown as ToZod<PostUsers201>

/**
 * @description Bad Request
 */
export const postUsers400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostUsers400>

/**
 * @description Создание пользователя
 */
export const postUsersMutationRequestSchema = z.lazy(() => createUserRequestSchema) as unknown as ToZod<PostUsersMutationRequest>

export const postUsersMutationResponseSchema = z.lazy(() => postUsers201Schema) as unknown as ToZod<PostUsersMutationResponse>